import { render, staticRenderFns } from "./PriceType.vue?vue&type=template&id=1cfa1ce4&scoped=true&"
import script from "./PriceType.vue?vue&type=script&lang=js&"
export * from "./PriceType.vue?vue&type=script&lang=js&"
import style0 from "./PriceType.vue?vue&type=style&index=0&id=1cfa1ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfa1ce4",
  null
  
)

export default component.exports